import { Typography } from "@material-ui/core";
import React, { Fragment } from "react";

export default () => {
  return (
    <Fragment>
      <Typography align="justify">
        I am an exteremely motivated programmer who have been programming for
        more than 7 years and have 2.5 years of industry-level experience.
        <br />
        <br />I am <strong>natural problem solver</strong>,{" "}
        <strong>fast learner</strong> and <strong>self-taught</strong>{" "}
        programmer who is perfectly capable of accomplishing things{" "}
        <strong>without</strong> any supervision. My other skills include
        <strong>Flexibility</strong>, <strong>Commitment</strong> and
        <strong>team-work</strong>. I am currently studying B.Sc. of Electrical
        Engineering at SBU and I am at the top of my field there.
        <br />
        <br />
        I've taken an interest in AI since late 2017s and given that I do have
        the required mathematical background, I started learning and
        implementing models. At first I started with NLP and Sentiment Analysis,
        but then switched my field of study to <strong>CNNs</strong>,{" "}
        <strong>CapsuleNets</strong>, <strong>LSTMs</strong> and most recently,
        Generative Models (<strong>GANs</strong>). I also have a paper on
        “Emotion Recognition via fMRI-derived Brain States using Deep Neural
        Networks” in IHBM 2020 conference.
        <br />
        <br />I also am a Web Developer who had the honor of working on a
        national project with Ministry of Roads and Urban Developement (
        <strong>MRUD</strong>) in 2018-2019. (For the second time in the whole
        world)
        <br />
        <br />
        And lastly, the things that I am passionate about are: F1, Football and
        Linkin Park.
      </Typography>
    </Fragment>
  );
};
